import { useState } from "react";

interface ActionBarProps {
  onPublishClick: () => void;
}

export default function ActionBar({ onPublishClick }: ActionBarProps) {
  const [savedVersion, setSavedVersion] = useState(false);
  const [regenerating, setRegenerating] = useState(false);

  const handleSave = () => {
    setSavedVersion(true);
    setTimeout(() => setSavedVersion(false), 2500);
  };

  const handleRegenerate = () => {
    setRegenerating(true);
    setTimeout(() => setRegenerating(false), 2500);
  };

  return (
    <div className="flex items-center justify-between bg-[#0F1419] border border-white/8 rounded-2xl px-5 py-3">
      {/* Left: secondary action */}
      <button
        onClick={handleRegenerate}
        className={`flex items-center gap-2 text-sm px-4 py-2.5 rounded-xl border transition-all cursor-pointer whitespace-nowrap ${
          regenerating
            ? "border-[#00D9FF]/40 bg-[#00D9FF]/8 text-[#00D9FF]"
            : "border-white/10 bg-white/4 text-gray-400 hover:text-white hover:border-white/20"
        }`}
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className={`ri-robot-2-line ${regenerating ? "animate-pulse" : ""}`} />
        </span>
        {regenerating ? "AI 재생성 중..." : "AI로 재생성"}
      </button>

      {/* Right: primary actions */}
      <div className="flex items-center gap-2">
        {/* Save Version */}
        <button
          onClick={handleSave}
          className={`flex items-center gap-2 text-sm px-4 py-2.5 rounded-xl border transition-all cursor-pointer whitespace-nowrap ${
            savedVersion
              ? "border-[#10B981]/40 bg-[#10B981]/10 text-[#10B981]"
              : "border-white/10 bg-white/4 text-gray-300 hover:text-white hover:border-white/20"
          }`}
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className={savedVersion ? "ri-check-line" : "ri-save-line"} />
          </span>
          {savedVersion ? "저장됨" : "버전 저장"}
        </button>

        {/* Download */}
        <button
          className="flex items-center gap-2 text-sm px-5 py-2.5 rounded-xl border border-white/15 bg-white/8 text-white hover:bg-white/12 transition-all cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 }}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-download-2-line" />
          </span>
          다운로드
        </button>

        {/* Publish (locked) */}
        <button
          onClick={onPublishClick}
          className="relative flex items-center gap-2 text-sm px-5 py-2.5 rounded-xl transition-all cursor-pointer overflow-hidden whitespace-nowrap group"
          style={{
            background: "linear-gradient(135deg, #00D9FF22, #10B98122)",
            border: "1px solid rgba(0,217,255,0.3)",
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 600,
            color: "rgba(255,255,255,0.5)",
          }}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-lock-line text-gray-500 text-sm" />
          </span>
          <span className="text-gray-400">게시하기</span>
          {/* Hover tooltip */}
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 hidden group-hover:flex items-center gap-1.5 bg-[#0A0E14] border border-[#00D9FF]/30 rounded-lg px-3 py-1.5 whitespace-nowrap">
            <i className="ri-lock-line text-[#00D9FF] text-xs" />
            <span className="text-white text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>회원가입 후 이용 가능</span>
          </div>
        </button>
      </div>
    </div>
  );
}
